var map = {
	"./ant_1.mp3": 63866,
	"./ant_2.mp3": 52237,
	"./at_1.mp3": 59684,
	"./at_2.mp3": 64123,
	"./axe.mp3": 64813,
	"./back_1.mp3": 60414,
	"./back_2.mp3": 32849,
	"./bake.mp3": 66584,
	"./bat.mp3": 64376,
	"./beast.mp3": 9372,
	"./bee_1.mp3": 64037,
	"./bee_2.mp3": 73490,
	"./bin.mp3": 94826,
	"./binbin.mp3": 42941,
	"./block.mp3": 40798,
	"./boat.mp3": 32205,
	"./boot_1.mp3": 52211,
	"./boot_2.mp3": 91836,
	"./born_1.mp3": 74746,
	"./born_2.mp3": 77645,
	"./boss.mp3": 89356,
	"./box.mp3": 64806,
	"./car_1.mp3": 42879,
	"./car_2.mp3": 50152,
	"./cash_1.mp3": 28558,
	"./cash_2.mp3": 16001,
	"./cat.mp3": 71633,
	"./cheer.mp3": 93510,
	"./chip_1.mp3": 75341,
	"./chip_2.mp3": 72442,
	"./coast.mp3": 70611,
	"./coat.mp3": 96790,
	"./conn.mp3": 69489,
	"./corn.mp3": 80725,
	"./cost.mp3": 31288,
	"./cot.mp3": 37487,
	"./day.mp3": 339,
	"./day_1.mp3": 15283,
	"./day_2.mp3": 54908,
	"./deck.mp3": 52024,
	"./dip.mp3": 77886,
	"./ditch.mp3": 28107,
	"./dog.mp3": 33511,
	"./door.mp3": 60271,
	"./due.mp3": 48523,
	"./egg.mp3": 24162,
	"./egg_1.mp3": 45250,
	"./egg_2.mp3": 55029,
	"./fade.mp3": 34749,
	"./fall.mp3": 88520,
	"./fan_1.mp3": 40278,
	"./fan_2.mp3": 69705,
	"./fat.mp3": 97524,
	"./fat_1.mp3": 80544,
	"./fat_2.mp3": 35735,
	"./fate.mp3": 32109,
	"./feast.mp3": 14576,
	"./feet.mp3": 86331,
	"./feet_1.mp3": 63435,
	"./feet_2.mp3": 28116,
	"./fern.mp3": 80372,
	"./file_float.mp3": 32338,
	"./fin.mp3": 70294,
	"./find.mp3": 53734,
	"./fine.mp3": 98155,
	"./fleet.mp3": 61961,
	"./flip.mp3": 24834,
	"./float.mp3": 25075,
	"./fold.mp3": 16382,
	"./fort.mp3": 10860,
	"./fox_1.mp3": 33970,
	"./fox_2.mp3": 1541,
	"./fuel.mp3": 65747,
	"./fun.mp3": 54730,
	"./gate.mp3": 79342,
	"./get.mp3": 72961,
	"./goat.mp3": 89362,
	"./gold.mp3": 24789,
	"./hard.mp3": 11836,
	"./hat.mp3": 97526,
	"./hate.mp3": 75179,
	"./hay.mp3": 75223,
	"./head.mp3": 50901,
	"./hen.mp3": 68320,
	"./her_1.mp3": 46688,
	"./her_2.mp3": 53463,
	"./herd.mp3": 25448,
	"./hitch.mp3": 59991,
	"./hog.mp3": 79963,
	"./hole.mp3": 38949,
	"./hook_1.mp3": 72806,
	"./hook_2.mp3": 84281,
	"./hoop.mp3": 29161,
	"./hop.mp3": 46456,
	"./hose.mp3": 68132,
	"./hot.mp3": 18452,
	"./hut.mp3": 26650,
	"./inch.mp3": 36811,
	"./ink.mp3": 7849,
	"./it_1.mp3": 844,
	"./it_2.mp3": 24035,
	"./itch.mp3": 61421,
	"./jet_1.mp3": 21072,
	"./jet_2.mp3": 76007,
	"./jog_1.mp3": 32537,
	"./jog_2.mp3": 15174,
	"./jug.mp3": 4411,
	"./kay.mp3": 58544,
	"./king.mp3": 26162,
	"./kite.mp3": 54114,
	"./kite_1.mp3": 43074,
	"./kite_2.mp3": 87605,
	"./laid.mp3": 54613,
	"./lake.mp3": 26362,
	"./land_1.mp3": 79480,
	"./land_2.mp3": 95727,
	"./let.mp3": 71534,
	"./lid.mp3": 7850,
	"./lied.mp3": 68297,
	"./line.mp3": 45337,
	"./lip.mp3": 62070,
	"./lock.mp3": 37126,
	"./long_1.mp3": 59841,
	"./long_2.mp3": 33902,
	"./loss.mp3": 72510,
	"./make.mp3": 94521,
	"./mat.mp3": 77051,
	"./mate_1.mp3": 73252,
	"./mate_2.mp3": 29531,
	"./may.mp3": 83122,
	"./men.mp3": 93885,
	"./moat.mp3": 34016,
	"./mole.mp3": 95886,
	"./mop_1.mp3": 2101,
	"./mop_2.mp3": 57570,
	"./more.mp3": 92760,
	"./moth_1.mp3": 59455,
	"./moth_2.mp3": 24200,
	"./nap.mp3": 28160,
	"./nest.mp3": 597,
	"./new_1.mp3": 26807,
	"./new_2.mp3": 62560,
	"./night_1.mp3": 95639,
	"./night_2.mp3": 31392,
	"./nine.mp3": 80099,
	"./nip.mp3": 26856,
	"./nit.mp3": 68900,
	"./nose.mp3": 54246,
	"./not.mp3": 92462,
	"./note.mp3": 86707,
	"./olive_1.mp3": 95752,
	"./olive_2.mp3": 88479,
	"./out_1.mp3": 19645,
	"./out_2.mp3": 27914,
	"./ox.mp3": 99134,
	"./ox_1.mp3": 37190,
	"./ox_2.mp3": 54553,
	"./pack.mp3": 71824,
	"./pain.mp3": 16707,
	"./peel.mp3": 30969,
	"./pick.mp3": 38920,
	"./pie_1.mp3": 47419,
	"./pie_2.mp3": 84100,
	"./pin.mp3": 39788,
	"./pinch.mp3": 33537,
	"./pine.mp3": 19445,
	"./pink.mp3": 6475,
	"./pink_2.mp3": 33092,
	"./pip.mp3": 26010,
	"./pit.mp3": 58326,
	"./pitch.mp3": 80287,
	"./pop_1.mp3": 73412,
	"./pop_2.mp3": 77851,
	"./pug.mp3": 75653,
	"./quiz_1.mp3": 2816,
	"./quiz_2.mp3": 58007,
	"./rake.mp3": 96200,
	"./ran.mp3": 46421,
	"./rang.mp3": 23109,
	"./rat.mp3": 26408,
	"./rate.mp3": 25857,
	"./rest.mp3": 41377,
	"./rest_1.mp3": 85045,
	"./rest_2.mp3": 40514,
	"./right_1.mp3": 68787,
	"./right_2.mp3": 39036,
	"./ring.mp3": 96621,
	"./rip.mp3": 61324,
	"./roll.mp3": 7842,
	"./roll_2.mp3": 63413,
	"./root.mp3": 60867,
	"./rose.mp3": 96866,
	"./rot.mp3": 50578,
	"./rut.mp3": 54492,
	"./sack_1.mp3": 87501,
	"./sack_2.mp3": 53978,
	"./seal.mp3": 50672,
	"./self.mp3": 921,
	"./shelf.mp3": 9909,
	"./shot.mp3": 43883,
	"./shout.mp3": 5190,
	"./sick.mp3": 39713,
	"./sink.mp3": 99262,
	"./six_1.mp3": 28161,
	"./six_2.mp3": 59694,
	"./spot.mp3": 43555,
	"./spring.mp3": 93844,
	"./sprint.mp3": 67003,
	"./sun.mp3": 74343,
	"./sun_1.mp3": 15327,
	"./sun_2.mp3": 31656,
	"./sung.mp3": 63806,
	"./tack.mp3": 94684,
	"./tap.mp3": 92838,
	"./tax.mp3": 1950,
	"./ten.mp3": 87788,
	"./test.mp3": 7827,
	"./test_2.mp3": 35580,
	"./text.mp3": 83730,
	"./that_1.mp3": 30656,
	"./that_2.mp3": 21079,
	"./then.mp3": 14618,
	"./thick.mp3": 9530,
	"./thin.mp3": 61366,
	"./tick.mp3": 70532,
	"./tin.mp3": 77752,
	"./tin_2.mp3": 28243,
	"./toes.mp3": 63112,
	"./tot.mp3": 720,
	"./tote.mp3": 55289,
	"./trot.mp3": 43080,
	"./trout.mp3": 1971,
	"./tug.mp3": 30601,
	"./tug_2.mp3": 26458,
	"./up_1.mp3": 81644,
	"./up_2.mp3": 4835,
	"./vain.mp3": 51169,
	"./vet_1.mp3": 80276,
	"./vet_2.mp3": 31947,
	"./web_1.mp3": 17903,
	"./web_2.mp3": 75480,
	"./wit.mp3": 84754,
	"./with.mp3": 94503,
	"./wreck.mp3": 37503,
	"./year.mp3": 96396,
	"./yes_1.mp3": 5716,
	"./yes_2.mp3": 52683,
	"./zebra_1.mp3": 2637,
	"./zebra_2.mp3": 57466,
	"./zoo_1.mp3": 25553,
	"./zoo_2.mp3": 33566
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 72915;